import axiosInstance from "./AxiosConfig";

export const updateUserAPI = async (userData) => {
    try {
      const response = await axiosInstance.put(`/api/usuarios/${userData.get("id")}`, userData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      console.error("Error al actualizar usuario", error);
      throw error;
    }
};

export const fetchUserAPI = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/usuarios/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener usuario", error);
    throw error;
  }
};

export const validateCurrentPassword = async (id_usuario, currentPassword) => {
  const response = await axiosInstance.post("/api/usuarios/validate-password", {
    id_usuario,
    currentPassword,
  });
  return response.data;
};